import React from 'react';
import cx from 'classnames';
import { ToastContainer } from 'react-toastify';
import { ToastIcon } from '../ToastIcon/index.js';
import styles from './index.module.scss.js';
import { Close } from '../ToastIcon/icons/Close.js';

const TOAST_DEFAULT_CONFIG = {
  position: "top-right",
  autoClose: 1e4,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: void 0,
  theme: "light"
};
const Toast = ({
  progressBottom
}) => /* @__PURE__ */ React.createElement(
  ToastContainer,
  {
    ...TOAST_DEFAULT_CONFIG,
    className: cx(styles["toast-container"], {
      toastGlobalProgressBottom: progressBottom
    }),
    toastClassName: () => cx(styles.toast, {
      [styles["toast-progress-bottom"]]: progressBottom
    }),
    progressClassName: styles["progress-bar"],
    icon: ({ type, ...props }) => /* @__PURE__ */ React.createElement(ToastIcon, { type, ...props }),
    closeButton: ({ closeToast }) => /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "Toastify__close-button",
        onClick: closeToast,
        "aria-label": "Close",
        type: "button"
      },
      /* @__PURE__ */ React.createElement(Close, null)
    )
  }
);
Toast.displayName = "Toast";

export { TOAST_DEFAULT_CONFIG, Toast };
//# sourceMappingURL=index.js.map
